"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FindOrCreate = exports.TimeStamps = void 0;
const tslib_1 = require("tslib");
const modelOptions_1 = require("./modelOptions");
let TimeStamps = class TimeStamps {
};
TimeStamps = tslib_1.__decorate([
    (0, modelOptions_1.modelOptions)({ schemaOptions: { timestamps: true } })
    /**
     * This class can be used for already existing type information for the Timestamps
     */
], TimeStamps);
exports.TimeStamps = TimeStamps;
/**
 * This class contains all types for the module "mongoose-findorcreate"
 */
class FindOrCreate {
}
exports.FindOrCreate = FindOrCreate;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmYXVsdENsYXNzZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvZGVmYXVsdENsYXNzZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7OztBQUNBLGlEQUE4QztBQU92QyxJQUFlLFVBQVUsR0FBekIsTUFBZSxVQUFVO0NBRy9CLENBQUE7QUFIcUIsVUFBVTtJQUovQixJQUFBLDJCQUFZLEVBQUMsRUFBRSxhQUFhLEVBQUUsRUFBRSxVQUFVLEVBQUUsSUFBSSxFQUFFLEVBQUUsQ0FBQztJQUN0RDs7T0FFRztHQUNtQixVQUFVLENBRy9CO0FBSHFCLGdDQUFVO0FBcUJoQzs7R0FFRztBQUNILE1BQXNCLFlBQVk7Q0FNakM7QUFORCxvQ0FNQyJ9